export const SearchTabs = Object.freeze({
  POSTS: 'Post',
  RESOURCES: 'CareProvider',
});
